import { useRef, useState } from "react"
import styled from "styled-components"
import { useT } from "react-polyglot-hooks"
import * as PropTypes from "prop-types"
import slice from "lodash/slice"
import { scrollToRef } from "helpers/scroll"
import { sendEvent } from "scripts/GoogleAnalytics"
import Typography from "../../styled/Typography"
import Col from "../../styled/Grid/Col"
import { Row } from "../../styled/Grid"
import Icon from "../../icons/icon"
import { Verified } from "../../icons/verified"

const Wrapper = styled.div`
  margin-bottom: 25px;
`

const Extra = styled.div`
  display: inline-flex;
  align-items: center;
  background: white;
  padding: 5px 10px;
  margin: 5px 0;
  width: auto;
  max-width: 300px;
  border-radius: 14px;

  svg {
    flex: 1 0 auto;
  }
`

const Text = styled(Typography)`
  margin-left: 10px;
  line-height: 16px;
`

const ShowMore = styled(Typography)`
  margin: 25px 0;
  cursor: pointer;
`

export default function FeaturedExtras(props) {
  const { list, page } = props
  const t = useT()
  const ref = useRef(null)
  const [showAll, setShowAll] = useState(false)

  const toggle = () => {
    if (showAll) scrollToRef(ref)
    sendEvent("Extras", { event_category: page, event_label: showAll ? "View less" : "View more" })
    setShowAll(!showAll)
  }

  return (
    <Wrapper ref={ref}>
      <Typography variant="title3" weight="medium">
        {t("car_data.extras.featured")}
      </Typography>
      <Row>
        {(showAll ? list : slice(list, 0, 6)).map(extra => (
          <Col xs={12} md={6} key={extra}>
            <Extra>
              <Icon color="skyBlue" Icon={Verified} />
              <Text variant="small" weight="medium">
                {extra}
              </Text>
            </Extra>
          </Col>
        ))}
      </Row>
      {list.length > 6 && (
        <ShowMore variant="small" weight="light" color="deepPink" onClick={toggle}>
          {t(`common.view_${showAll ? "less" : "more"}`)}
        </ShowMore>
      )}
    </Wrapper>
  )
}

FeaturedExtras.defaultProps = {
  list: []
}

FeaturedExtras.propTypes = {
  list: PropTypes.array,
  page: PropTypes.string.isRequired
}
